export interface FormMeta {
  revenueType?: string;
  voucherType?: string;
  reason?: string;
}

const readValue = (form: HTMLFormElement, name: string): string | undefined => {
  const element = form.elements.namedItem(name);
  if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
    return element.value || undefined;
  }
  return undefined;
};

// These values only live in the form inputs (not in VoucherFormContext). Read via
// form.elements rather than FormData, as FormData skips the disabled type inputs.
export const readFormMeta = (form: HTMLFormElement | null | undefined): FormMeta => {
  if (!form) return {};

  return {
    revenueType: readValue(form, 'revenue-type'),
    voucherType: readValue(form, 'voucher-type'),
    reason: readValue(form, 'reason'),
  };
};
